(function () {
  const container = document.getElementById('reels-section');
  const grid = document.getElementById('reels-grid');
  const loading = document.getElementById('reels-loading');
  if (!container) return;

  const WORKER_URL = 'https://reels-proxy.dev-avaniglobal.workers.dev';
  const shop = container.dataset.shop;
  const columns = container.dataset.columns || 4;
  const gap = container.dataset.gap || 12;
  const igHandle = container.dataset.igHandle || '';
  const isMobile = () => window.innerWidth <= 640;

  container.style.setProperty('--reels-columns', columns);
  container.style.setProperty('--reels-gap', gap + 'px');

  let reelsData = [];
  let currentIndex = 0;
  let muted = true;

  if (igHandle) {
  const headingWrap = container.querySelector('.reels-heading');
  const heading = container.querySelector('.reels-heading h2');
  if (heading && headingWrap) {
    // Add icon to heading

    // Add handle badge below
    const badge = document.createElement('div');
    badge.className = 'reels-handle-badge';
    badge.innerHTML = `
      <a href="https://instagram.com/${igHandle.replace('@','')}" target="_blank" rel="noopener" class="reels-handle-tag">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>
        @${igHandle.replace('@','')}
      </a>`;
    headingWrap.appendChild(badge);
  }
}

  // ── Modal ──
  const modal = document.createElement('div');
  modal.id = 'reel-modal';
  modal.innerHTML = `
    <div class="rm-backdrop"></div>
    <div class="rm-dialog">
      <button class="rm-close" aria-label="Close">✕</button>
      <button class="rm-nav rm-prev" aria-label="Previous">&#8249;</button>
      <button class="rm-nav rm-next" aria-label="Next">&#8250;</button>
      <div class="rm-media-wrap" id="rm-media-wrap"></div>
      <div class="rm-bottom">
        <div class="rm-bottom-top">
          <button class="rm-mute" id="rm-mute-btn">🔇 Unmute</button>
          ${igHandle ? `<a class="rm-ig-link" href="https://instagram.com/${igHandle.replace('@','')}" target="_blank" rel="noopener">@${igHandle.replace('@','')}</a>` : ''}
        </div>
        <div class="rm-dots" id="rm-dots"></div>
        <div class="rm-caption" id="rm-caption"></div>
      </div>
    </div>`;
  document.body.appendChild(modal);

  // ── Styles ──
  const style = document.createElement('style');
  style.textContent = `
    .reels-ig-link {
      color: inherit;
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      transition: opacity .2s;
    }
    .reels-ig-link:hover { opacity: .7; }

    /* Mobile slider */
    @media (max-width: 640px) {
      #reels-section { padding: 20px 0 !important; }
      .reels-heading { padding: 0 16px !important; margin-bottom: 14px !important; }
      #reels-grid {
        display: flex !important;
        flex-wrap: nowrap !important;
        overflow-x: auto !important;
        scroll-snap-type: x mandatory !important;
        -webkit-overflow-scrolling: touch !important;
        gap: 8px !important;
        padding: 0 16px 8px !important;
        scrollbar-width: none !important;
      }
      #reels-grid::-webkit-scrollbar { display: none !important; }
      .reel-card {
        flex: 0 0 calc(50% - 4px) !important;
        min-width: calc(50% - 4px) !important;
        scroll-snap-align: start !important;
        border-radius: 10px !important;
        aspect-ratio: 9/16 !important;
      }
      .reel-card:last-child {
        margin-right: 16px;
      }
    }

    /* Modal */
    #reel-modal {
      display: none;
      position: fixed;
      inset: 0;
      z-index: 99999;
      align-items: center;
      justify-content: center;
    }
    #reel-modal.open { display: flex; }
    .rm-backdrop {
      position: absolute;
      inset: 0;
      background: rgba(0,0,0,.88);
      cursor: pointer;
    }
    .rm-dialog {
      position: relative;
      z-index: 1;
      width: min(360px, 88vw);
      aspect-ratio: 9/16;
      background: #000;
      border-radius: 14px;
      overflow: hidden;
    }
    .rm-media-wrap {
      width: 100%;
      height: 100%;
      position: relative;
    }
    .rm-media-wrap img,
    .rm-media-wrap video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    .rm-close {
      position: absolute;
      top: 12px; right: 12px;
      z-index: 10;
      background: rgba(0,0,0,.5);
      color: #fff;
      border: none;
      width: 30px; height: 30px;
      border-radius: 50%;
      font-size: 13px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      backdrop-filter: blur(4px);
    }
    .rm-nav {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 10;
      background: rgba(0,0,0,.4);
      color: #fff;
      border: none;
      width: 34px; height: 34px;
      border-radius: 50%;
      font-size: 22px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      backdrop-filter: blur(4px);
      transition: background .15s;
    }
    .rm-nav:hover { background: rgba(0,0,0,.65); }
    .rm-prev { left: 10px; }
    .rm-next { right: 10px; }
    .rm-bottom {
      position: absolute;
      bottom: 0; left: 0; right: 0;
      padding: 10px 14px 14px;
      background: linear-gradient(transparent, rgba(0,0,0,.75));
    }
    .rm-bottom-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
    }
    .rm-mute {
      background: rgba(255,255,255,.15);
      color: #fff;
      border: 1px solid rgba(255,255,255,.25);
      padding: 3px 10px;
      border-radius: 20px;
      font-size: 11px;
      cursor: pointer;
    }
    .rm-ig-link {
      color: #fff;
      font-size: 11px;
      text-decoration: none;
      opacity: .8;
    }
    .rm-ig-link:hover { opacity: 1; }
    .rm-dots {
      display: flex;
      gap: 4px;
      justify-content: center;
      margin-bottom: 7px;
      flex-wrap: wrap;
    }
    .rm-dot {
      width: 6px; height: 6px;
      border-radius: 50%;
      background: rgba(255,255,255,.35);
      cursor: pointer;
      transition: all .2s;
      flex-shrink: 0;
    }
    .rm-dot.active {
      background: #fff;
      width: 16px;
      border-radius: 3px;
    }
    .rm-caption {
      font-size: 11px;
      color: rgba(255,255,255,.85);
      line-height: 1.4;
      max-height: 44px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  `;
  document.head.appendChild(style);

  // ── Load reels ──
  const observer = new IntersectionObserver(
    entries => { entries.forEach(e => { if (e.isIntersecting) { loadReels(); observer.disconnect(); } }); },
    { threshold: 0.1 }
  );
  observer.observe(container);

  async function loadReels() {
    try {
      const selRes = await fetch(WORKER_URL + '?action=get_selected&shop=' + shop);
      const selData = await selRes.json();
      const ids = selData.ids || [];
      if (!ids.length) { loading.style.display = 'none'; return; }

      const res = await fetch(WORKER_URL + '?action=public&shop=' + shop + '&ids=' + ids.join(','));
      const data = await res.json();

      if (data.reels && data.reels.length) {
        reelsData = data.reels;
        renderGrid();
      } else {
        loading.style.display = 'none';
      }
    } catch(err) {
      loading.style.display = 'none';
    }
  }

  function renderGrid() {
    loading.style.display = 'none';
    grid.innerHTML = '';

    reelsData.forEach((reel, i) => {
      const card = document.createElement('div');
      card.className = 'reel-card';
      card.setAttribute('data-index', i);

      const isVideo = reel.media_type === 'VIDEO';

      if (isVideo) {
        card.innerHTML = `
          <video
            src="${reel.media_url}"
            poster="${reel.thumbnail_url || ''}"
            muted playsinline preload="none" loop
            class="reel-media"
          ></video>
          <div class="reel-play-icon">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21"/></svg>
          </div>`;

        const video = card.querySelector('video');
        const icon = card.querySelector('.reel-play-icon');

        if (isMobile()) {
          // Mobile: autoplay when card enters viewport
          const cardObserver = new IntersectionObserver(
            entries => {
              entries.forEach(e => {
                if (e.isIntersecting) { video.play(); icon.style.opacity = '0'; }
                else { video.pause(); video.currentTime = 0; icon.style.opacity = '1'; }
              });
            },
            { threshold: 0.6 }
          );
          cardObserver.observe(card);
        } else {
          // Desktop: hover to play
          card.addEventListener('mouseenter', () => { video.play(); icon.style.opacity = '0'; });
          card.addEventListener('mouseleave', () => { video.pause(); video.currentTime = 0; icon.style.opacity = '1'; });
        }
      } else {
        card.innerHTML = `
          <img
            src="${reel.media_url}"
            alt="${reel.caption ? reel.caption.substring(0, 40) : 'Instagram post'}"
            loading="lazy"
            class="reel-media"
          />`;
      }

      card.addEventListener('click', () => openModal(i));
      grid.appendChild(card);
    });
  }

  // ── Modal functions ──
  function openModal(index) {
    currentIndex = index;
    muted = true;
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
    renderModal();
  }

  function closeModal() {
    modal.classList.remove('open');
    document.body.style.overflow = '';
    const wrap = document.getElementById('rm-media-wrap');
    const video = wrap.querySelector('video');
    if (video) { video.pause(); video.src = ''; }
  }

  function renderModal() {
    const reel = reelsData[currentIndex];
    const wrap = document.getElementById('rm-media-wrap');
    const prev = wrap.querySelector('video');
    if (prev) { prev.pause(); prev.src = ''; }

    const isVideo = reel.media_type === 'VIDEO';
    wrap.innerHTML = isVideo
      ? `<video src="${reel.media_url}" playsinline autoplay muted loop style="width:100%;height:100%;object-fit:cover;"></video>`
      : `<img src="${reel.media_url}" alt="" style="width:100%;height:100%;object-fit:cover;"/>`;

    document.getElementById('rm-mute-btn').style.display = isVideo ? 'block' : 'none';
    document.getElementById('rm-mute-btn').textContent = '🔇 Unmute';
    document.getElementById('rm-caption').textContent = reel.caption || '';
    muted = true;
    updateDots();
  }

  function updateDots() {
    const dotsEl = document.getElementById('rm-dots');
    dotsEl.innerHTML = reelsData.map((_, i) =>
      `<div class="rm-dot ${i === currentIndex ? 'active' : ''}" data-i="${i}"></div>`
    ).join('');
    dotsEl.querySelectorAll('.rm-dot').forEach(d => {
      d.addEventListener('click', () => { currentIndex = +d.dataset.i; renderModal(); });
    });
  }

  function goNext() { currentIndex = (currentIndex + 1) % reelsData.length; renderModal(); }
  function goPrev() { currentIndex = (currentIndex - 1 + reelsData.length) % reelsData.length; renderModal(); }

  modal.querySelector('.rm-backdrop').addEventListener('click', closeModal);
  modal.querySelector('.rm-close').addEventListener('click', closeModal);
  modal.querySelector('.rm-next').addEventListener('click', goNext);
  modal.querySelector('.rm-prev').addEventListener('click', goPrev);

  document.getElementById('rm-mute-btn').addEventListener('click', () => {
    muted = !muted;
    const video = document.querySelector('#rm-media-wrap video');
    if (video) video.muted = muted;
    document.getElementById('rm-mute-btn').textContent = muted ? '🔇 Unmute' : '🔊 Mute';
  });

  document.addEventListener('keydown', e => {
    if (!modal.classList.contains('open')) return;
    if (e.key === 'ArrowRight') goNext();
    if (e.key === 'ArrowLeft') goPrev();
    if (e.key === 'Escape') closeModal();
  });

  let touchStartX = 0;
  modal.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
  modal.addEventListener('touchend', e => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) diff > 0 ? goNext() : goPrev();
  });

})();